import Vue from 'vue'
import Vuex from 'vuex'
import { templateBuilder } from './templateBuilder/index'

Vue.use(Vuex)

const store = {
  state: {
    version: '1.0.0'
  },
  modules: {
    templateBuilder
  }
}

export default new Vuex.Store(store)
